/**
 * Shared camera constraints for every capture surface in a gate transaction.
 *
 * A gate save now sends its photos in the same request as the transaction, so their combined size
 * decides how long that single connection stays open — and a connection held open at a truck lane
 * is exactly the window in which Rollbar #94's aborted uploads happened. Unconstrained capture on a
 * modern tablet produces multi-megapixel frames, and nine of them is several megabytes of base64.
 *
 * Resolution is capped rather than JPEG quality on purpose. Resolution is what dominates the
 * payload, and these are damage photos — they are the evidence in a damage claim, so re-compressing
 * them harder to save bytes trades away the thing they exist for. `screenshotQuality` is
 * deliberately left at react-webcam's high default.
 *
 * `ideal` rather than `max`: a device that cannot deliver this still works, it just gives what it
 * has.
 */
export const CAPTURE_VIDEO_CONSTRAINTS = {
  facingMode: 'environment',
  width: { ideal: 1600 },
  height: { ideal: 1200 }
} as const;
